import { useAuthContext } from '@shared/auth/AuthContext';
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useDemoMode = () => {
  const [params] = useSearchParams();
  const isDemoParam = params.get('demo') === 'true';
  const { ready, updateAuthState } = useAuthContext();
  const [showDemoDialog, setShowDemoDialog] = useState(false);

  useEffect(() => {
    if (!isDemoParam) {
      return;
    }

    const storedDemoEmail = localStorage.getItem('demoUserEmail');

    if (storedDemoEmail && !ready) {
      updateAuthState({
        isAuthenticated: false,
        user: undefined,
        isDemo: true,
        token: undefined,
        ready: true,
      });
    } else if (!storedDemoEmail && !showDemoDialog && !ready) {
      setShowDemoDialog(true);
      updateAuthState({
        isAuthenticated: false,
        user: undefined,
        isDemo: true,
        token: undefined,
        ready: false,
      });
    }
  }, [isDemoParam, ready, showDemoDialog, updateAuthState]);

  return {
    isDemoParam,
    showDemoDialog,
    setShowDemoDialog,
  };
};

export const isDemo = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('demo') === 'true';
};

export const getUserDemoEmailFromLocalStorage = () => {
  return localStorage.getItem('demoUserEmail');
};
